module.exports = __webpack_public_path__ + "static/media/competency_active.ee5a4f41.svg";